// Knot & Ease: scroll reveals for ke-* sections. Elements stay visible without JS or with reduced motion.
(() => {
  const reveal = (root = document) => {
    const items = root.querySelectorAll('.ke-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    items.forEach((el) => io.observe(el));
  };
  document.addEventListener('DOMContentLoaded', () => reveal());
  document.addEventListener('shopify:section:load', (e) => reveal(e.target));
})();

// Copy-to-clipboard for the welcome code
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-ke-copy]');
  if (!btn) return;
  navigator.clipboard?.writeText(btn.dataset.keCopy).then(() => {
    const label = btn.querySelector('[data-ke-copy-label]');
    if (label) label.textContent = 'Copied ✓';
  });
});

// Welcome popup: once per N days, never after signing up, opens after a delay or on exit intent
(() => {
  const KEY = 'ke-pop-seen';
  const init = () => {
    const pop = document.getElementById('ke-pop');
    if (!pop || typeof pop.showModal !== 'function') return;
    const days = Number(pop.dataset.days || 10);
    const posted = location.search.includes('customer_posted=true');
    let seen = 0;
    try {
      seen = Number(localStorage.getItem(KEY) || 0);
    } catch (err) {}
    const remember = () => {
      try {
        localStorage.setItem(KEY, String(Date.now()));
      } catch (err) {}
    };
    pop.addEventListener('click', (e) => {
      if (e.target === pop || e.target.closest('[data-ke-pop-close]')) {
        pop.close();
      }
    });
    pop.addEventListener('close', remember);

    // a successful signup from the popup reloads the page: show the code inside the popup again
    if (posted && location.hash === '#ke-pop-form') {
      pop.showModal();
      remember();
      return;
    }
    if (posted || (seen && Date.now() - seen < days * 864e5)) return;
    if (/\/(cart|checkouts|account)/.test(location.pathname)) return;

    let opened = false;
    const open = () => {
      if (opened || document.querySelector('dialog[open]')) return;
      opened = true;
      pop.showModal();
    };
    setTimeout(open, Number(pop.dataset.delay || 12) * 1000);
    document.addEventListener('mouseout', (e) => {
      if (!e.relatedTarget && e.clientY < 8) open();
    });
  };
  document.addEventListener('DOMContentLoaded', init);
})();
